﻿import React from 'react';
import "./Notifier.scss";
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { removeSnackbar } from '../../store/notifications/actions';
import { RootState } from '../../store';

let displayed = [];

export default function Notifier() {
    const dispatch = useDispatch();
    const notifications = useSelector((store: RootState) => store.notifications.notifications || []);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const storeDisplayed = (id: string) => {
        displayed = [...displayed, id];
    };

    const removeDisplayed = (id: string) => {
        displayed = [...displayed.filter(key => id !== key)];
    };

    React.useEffect(() => {
        notifications.forEach(({ key, message, options = { onClose: null }, dismissed = false }) => {
            if (dismissed) {
                // Dismiss snackbar using notistack
                closeSnackbar(key);
                return;
            }

            // Do nothing if snackbar is already displayed
            if (displayed.includes(key)) return;

            // Display snackbar using notistack
            enqueueSnackbar(message, {
                key,
                ...options,
                className: "snackbar-root",
                onClose: (event, reason, myKey) => {
                    if (options.onClose) {
                        options.onClose(event, reason, myKey?.toString());
                    }
                },
                onExited: (_event, myKey) => {
                    // Remove this snackbar from redux store
                    dispatch(removeSnackbar(myKey?.toString()));
                    removeDisplayed(myKey?.toString());
                },
            });

            // keep track of snackbars that we've displayed
            storeDisplayed(key);
        });
    }, [notifications, closeSnackbar, enqueueSnackbar, dispatch]);

    return null;
};